import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, model, Output, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DxTextBoxModule, DxValidatorModule } from 'devextreme-angular';
import { DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { SvgIconComponent } from '../../../../../../components/svg-icon/svg-icon.component';

@Component({
    selector: 'app-project-config-node',
    imports: [CommonModule, FormsModule, DxTextBoxModule, DxValidatorModule, DxiValidationRuleModule, SvgIconComponent],
    templateUrl: './project-config-node.component.html',
    styleUrl: './project-config-node.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectConfigNodeComponent {
  @Input() itemNumber!: number;
  @Input() value: string = '';
  @Input() placeholder: string = '';
  @Input() isEditing: boolean = false;
  @Input() validationCallback?: (value: string) => boolean;
  @Input() allowEdit: boolean = true;
  @Input() allowDelete: boolean = true;
  @Input() isArchived: boolean = false;
  @Input() allowArchive: boolean = false;
  @Input() color: string = '';
  @Input() displayTemplate?: TemplateRef<any>;
  @Input() editTemplate?: TemplateRef<any>;

  @Output() onSave = new EventEmitter<VoidFunction>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();
  @Output() onStartEdit = new EventEmitter<void>();
  @Output() onArchive = new EventEmitter<void>();
  @Output() onReactivate = new EventEmitter<void>();
  @Output() hovering = new EventEmitter<boolean>();

  selected = model<boolean>(false);

  editValue: string = '';
  validationMessage: string = $localize`:@@nameAlreadyExists:Name already Exists.`;

  // Properties to match project config node interface
  private changes: boolean = false;
  public isValid: boolean | null = null;

  startEdit() {
    this.editValue = this.value;
    this.onStartEdit.emit();
  }

  save() {
    this.onSave.emit();
  }

  uniqueNameValidation = (params: any) => {
    const value = params?.value?.trim();
    if (!value) return false; // Required field

    if (this.validationCallback) {
      return this.validationCallback(value);
    }

    return true;
  };

  cancel() {
    this.editValue = '';
    this.onCancel.emit();
  }

  // Method to toggle editing state (can be called from template)
  toggleEdit() {
    if (this.isEditing) {
      this.cancel();
    } else {
      this.startEdit();
    }
  }

  // Method for form validation (similar to project config nodes)
  validateForm(): boolean {
    if (this.validationCallback) {
      return this.validationCallback(this.editValue);
    }
    return this.editValue.trim().length > 0;
  }

  // Validation callback for external form validation
  validationFormCallback = () => {
    if (this.changes || this.isValid === null) {
      this.isValid = this.validateForm();
      this.changes = false;
    }
    return this.isValid ?? this.validateForm();
  };
}
